export const getInitials = (name?: string) => {
  if (!name) {
    return ''
  }

  const words = name.split(' ')
  return words.map((word) => word.substring(0, 1).toUpperCase()).join('')
}

export const getUserInitials = (userName: string) => {
  const initials = getInitials(userName)
  const initialsArray = initials.split('')

  return initialsArray.length > 2
    ? `${initialsArray[0]}${initialsArray[2]}`
    : initials.substring(0, 2)
}
